export const homeObjOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "4AM Basketball Camp",
  headline: "Established to honour the life of Andrew Milner.",
  description:
    "During the camp, we aim to teach not only the basketball skills that made Andrew an exceptional player, but also the life skills that Andrew embodied as a phenomenal young man. All of the proceeds from the camp go towards an annual award in Andrew's name.",
  imgStart: "start",
  img: "images/HomePage-2.JPG",
  alt: "Baller",
};

export const homeObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Andrew Milner",
  headline: "“Never forget what made you who you are.”",
  description:
    "Andrew Milner was a Nova Scotian basketball player whose impact stretched far beyond the lines of a basketball court.",
  imgStart: "",
  img: "images/Andrew-Attacking-Dinos.jpg",
  alt: "Credit Card",
  button: true
};

